<template>
  <ul class="tab">
    <li v-for="(item, i) in list" :key="i">
      <button
        type="button"
        class="tab_btn"
        :class="{
          '-current': i === current,
          '-isPC': isPC
        }"
        @click="clickTab(i)"
      >
        {{ item.label }}
      </button>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'

interface TabItem {
  label: string
  name?: string
  link?: string
}

export default defineComponent({
  name: 'Tab',

  props: {
    list: {
      type: Array as PropType<TabItem[]>,
      required: true
    },
    current: {
      type: Number,
      default: 0
    },
    isPC: {
      type: Boolean,
      default: false
    }
  },

  setup(_, { emit }) {
    const clickTab = (index: number) => emit('click-tab', index)

    return {
      clickTab
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.tab {
  display: flex;
  white-space: nowrap;
  overflow-x: auto;
  border-bottom: 1px solid var.$color-border-gray;

  &_btn {
    color: var.$color-main;
    font-size: 1.4rem;
    font-weight: 500;
    height: 48px;
    line-height: 1.5;
    padding: 0 16px;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    &:hover {
      opacity: 1;
      background-color: #e5f7f6;
    }

    &.-current {
      background-color: var.$color-main;
      color: #fff;
    }

    @include mixins.media() {
      &.-isPC {
        height: 72px;
        padding: 0 40px;
      }
    }
  }

  &.-mypage {
    // margin-left: -16px;
    // margin-right: -16px;
    // margin-bottom: 42px;
    @include mixins.media() {
      display: none;
    }
    li {
      flex-basis: 50%;
      button {
        width: 100%;
        justify-content: center;
      }
    }
  }
}
</style>
